import { ArticleType } from './../../../article-types/article-type.model';
import { IdGeneratorService } from '../../../../services/id-generator.service';
import { ArticleTypeService } from './../../../article-types/article-type.service';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator as MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { AppClientConfigurationService, AppServerAPI, DialogService, NumberFormatService } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { AddArticleEntry, Article, ArticleEntry, Catalog, CatalogColumnDefinitions, CatalogDetails, CatalogNode, CatalogTableGroupHeader } from '../../catalog.model';
import { AddArticleTypeSelectionComponent } from '../add-article-type-selection/add-article-type-selection.component';
import { AddCatalogNodeDialogComponent } from '../add-catalog-node-dialog/add-catalog-node-dialog.component';
import { ArticleEditorComponent } from '../article-editor/article-editor.component';
import { CatalogAdminComponent } from '../catalog-admin/catalog-admin.component';
import { ChangeCatalogNodeDialogComponent } from '../change-catalog-node-dialog.component.ts/change-catalog-node-dialog.component';
import { AttributeValueResolverService } from './../../pipe/attribute-value.service';


@Component({
    selector: 'app-catalog-structure',
    templateUrl: './catalog-structure.component.html',
    styleUrls: ['./catalog-structure.component.scss'],
    standalone: false
})
export class CatalogStructureComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  priceScale = 2;

  catalog: CatalogDetails;

  columnDefinitions: CatalogColumnDefinitions;

  displayedColumns: string[] = [];
  datasource: MatTableDataSource<any> = new MatTableDataSource<any>();

  constructor(
    private dialogService: DialogService,
    private articleTypeService: ArticleTypeService,
    private idGeneratorService: IdGeneratorService,
    private appServerAPI: AppServerAPI,
    private cps: AppClientConfigurationService,
    private numberFormatService: NumberFormatService,
    private attributeValueConverter: AttributeValueResolverService,
    public translationService: TranslationService
  ) {
    const tableHeaderDefinition = cps.getPropertyValue('erp.column-definition.articles', 'erp.entity.article.id');
    this.displayedColumns.push(...tableHeaderDefinition.split(','));
    this.displayedColumns.push('articleActions');
    this.priceScale = this.cps.getPropertyValue('erp.use-three-digit-prices', 'false') === 'true' ? 3 : 2;
  }


  @Input('catalog') set setCatalog(value: Catalog) {
    if (value != null) {
      this.appServerAPI
        .execute<CatalogDetails>('/client/erp-article/catalog/getCatalog', {id: value.id})
        .subscribe(value => {
          this.catalog = new CatalogDetails(value);
          this.buildTableModel();
      });
    }
  }

  @Input() catalogAdminComponent: CatalogAdminComponent;

  ngOnInit(): void {
    //this.datasource.paginator = this.paginator;
    this.appServerAPI
        .execute<CatalogColumnDefinitions>('/client/erp-article/catalog/getColumnDefinitions', {})
        .subscribe(value => {
          this.columnDefinitions = new CatalogColumnDefinitions(value);
          this.buildTableModel();
    });
  }

  isHeader(index, item): boolean{
    return item instanceof CatalogTableGroupHeader;
  }

  retrieveValueForColumn(index: number, field: string, articleEntry: ArticleEntry) {
    if (articleEntry == null) {
      return '';
    }

    const definitions = this.columnDefinitions?.definitions?.get('' + articleEntry.articleTypeId);

    if (definitions != null && definitions.length > 0) {
      const column = field;//definitions[index];
      if (column != null && column.indexOf('.') > 0) {
        const v = column.split('.');
        if (v[0] === 'article') {
          if (v[1] === 'id') {
            return articleEntry.articleId;
          } else if (v[1] === 'name') {
            return articleEntry.name?.getValue(this.translationService.language);
          } else if (v[1] === 'identifier') {
            return articleEntry.articleIdentifier;
          } else if (v[1] === 'retailPriceDaily') {
            return articleEntry.retailPriceDaily != null ? this.numberFormatService.format(articleEntry.retailPriceDaily.priceNet, this.priceScale) : '';
          }
        } else if (v[0] === 'attribute') {
          const articleType = this.articleTypeService.getById(articleEntry.articleTypeId).completeArticleType;
          if (articleEntry.valuesMap == null) {
          } else {
            const value = articleEntry.valuesMap.get(v[1]);
            return this.attributeValueConverter.transform(value, articleType.findArticleTypeAttributeById(Number.parseInt(v[1])));
          }
        }
      }
    }
    return '';
  }

  private buildTableModel() {
    let level = 0;
    if (this.catalog != null && this.catalog.nodes != null && this.catalog.nodes.length > 0) {
      const data = [];
      this.mapCataloNodesToTableModel(data, level, this.catalog.nodes);
      this.datasource = new MatTableDataSource(data);
      //this.datasource.paginator = this.paginator;

    }
  }

  private mapCataloNodesToTableModel(data: Array<any>, level: number, nodes: Array<CatalogNode>) {
    nodes.forEach(node => {
      data.push(new CatalogTableGroupHeader({level: level, name: node.name, catalogNode: node}));
      if (node.articleEntries != null && node.articleEntries.length > 0) {
        node.articleEntries.forEach(entry => {
          const fields = new Array<any>();
          fields.push(entry);
          const definitions = this.columnDefinitions?.definitions?.get('' + entry.articleTypeId);
          for (let i = 0; i < definitions.length; i++){
            const value = this.retrieveValueForColumn(i, definitions[i], entry);
            fields.push(value);
          }
          data.push(fields);
        });
      }
      if (node.nodes != null) {
        this.mapCataloNodesToTableModel(data, level + 1, node.nodes);
      }
    });
  }

  addArticle(node: CatalogNode) {
    let article = new Article({});
    this.dialogService.openDefault(AddArticleTypeSelectionComponent, { node: node, article: article })
      .afterClosed().subscribe(value => {
        if (value != null) {
          const article = new Article({ id: this.idGeneratorService.getNextId(), articleTypeId: value.id });
          // fill attributes with default values from articletype
          const articleType = this.articleTypeService.getById(value.id).completeArticleType;
          this.fillArticleWithAttributeDefaultValues(article, articleType);

          this.dialogService.openMaxHeight(ArticleEditorComponent, { articleType: value, article: article })
            .afterClosed().subscribe(createdArticle => {
              if (createdArticle != null ) {
                this.appServerAPI.execute<number>('/client/erp-article/catalog/addArticleEntry', new AddArticleEntry({ nodeId: node.id, articleId: createdArticle })).subscribe(response => {
                  this.catalogAdminComponent.readCatalogData();
                });
              }
            });
        }
      });
  }

  editArticle(articleEntry: ArticleEntry) {
    this.appServerAPI.execute<Article>('/client/erp-article/article/getArticle', { id: articleEntry.articleId })
      .subscribe(value => {
        if (value != null) {
          let article = new Article(value);
          this.dialogService.openMaxHeight(ArticleEditorComponent, { articleType: this.articleTypeService.getById(article.articleTypeId), article: article }).afterClosed().subscribe(value => {
            if (value != null) {
              this.catalogAdminComponent.readCatalogData();
            }
          });
        }
      });
  }

  removeArticle(articleEntry: ArticleEntry) {
    const dialogRef = this.dialogService.showConfirm('erp.ui.catalog.dialog.remove-article.title', 'erp.ui.catalog.dialog.remove-article.message');
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed === true) {
        const data = { articleEntryId: articleEntry.id };
        this.appServerAPI.execute<Article>('/client/erp-article/catalog/removeArticleEntry', data)
          .subscribe(value => {
            this.catalogAdminComponent.readCatalogData();
          });
        }
    });
  }

  addNode(node: CatalogNode) {
    this.dialogService.openDefault(AddCatalogNodeDialogComponent, { catalogId: this.catalog.id, parentNodeId: node.id })
      .afterClosed().subscribe(() => {
        this.catalogAdminComponent.readCatalogData();
      });
  }

  editNode(node: CatalogNode) {
    this.dialogService.openDefault(ChangeCatalogNodeDialogComponent, { catalogId: this.catalog.id, node: node })
      .afterClosed().subscribe(() => {
        this.catalogAdminComponent.readCatalogData();
      });
  }

  deleteNode(node: CatalogNode) {
    const dialogRef = this.dialogService.showConfirm('erp.ui.catalog.dialog.remove-catalognode.title', 'erp.ui.catalog.dialog.remove-catalognode.message');
    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed === true) {
        this.appServerAPI.execute<number>('/client/erp-article/catalog/deleteCatalogNode', { catalogId: this.catalog.id, nodeId: node.id })
          .subscribe(response => {
            this.catalogAdminComponent.readCatalogData();
          }, error => {
            console.log('error is', error);
          });
      }
    });

  }

  private fillArticleWithAttributeDefaultValues(article: Article, articleType: ArticleType) {
    for (const group of articleType.attributeGroups) {
      for (const attrib of group.attributes) {
        if ( attrib.defaultValueId != null) {
          article.valuesMap.set(attrib.id + '', attrib.defaultValueId + '');
        } else if (attrib.defaultValue != null) {
          article.valuesMap.set(attrib.id + '', attrib.defaultValue);
        }
      }
    }
  }

}
